import { createBrowserHistory } from 'history';
const history = createBrowserHistory({
    basename: '/star/'
});

export default history;